import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var FundraiseUpElement = _ref => {
  var {
    id
  } = _ref;
  return /*#__PURE__*/_jsx("a", {
    href: "#" + id,
    style: {
      display: "none"
    }
  });
};
//# sourceMappingURL=fundraiseup_element.js.map